export default "__VITE_ASSET__C0l6gj8Y__"